/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Property_PublishedInputs */

const cs_event_property_published = /** @type {(inputs: Event_Property_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost publikována`)
};

const en_event_property_published = /** @type {(inputs: Event_Property_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property published`)
};

/**
* | output |
* | --- |
* | "Property published" |
*
* @param {Event_Property_PublishedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const event_property_published = /** @type {((inputs?: Event_Property_PublishedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Property_PublishedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_property_published(inputs)
	return cs_event_property_published(inputs)
});